const CANONICAL_BLANK_RE = /\{\{blank_([^}]+)\}\}/g;
const UPPER_COLON_BLANK_RE = /\{\{BLANK:([^}]+)\}\}/g;
const BARE_BLANK_RE = /(?<![_{])blank(\d+)\}\}/g;
const LEGACY_NUMBERED_BLANK_RE = /(\d+)_{4,}/g;

const cloneGlobal = (re: RegExp) => new RegExp(re.source, re.flags);

export const normalizeBlankStem = (raw: string): string => {
	let out = raw.replace(
		cloneGlobal(UPPER_COLON_BLANK_RE),
		(_, n) => `{{blank_${n}}}`,
	);
	out = out.replace(cloneGlobal(BARE_BLANK_RE), (_, n) => `{{blank_${n}}}`);
	out = out.replace(
		cloneGlobal(LEGACY_NUMBERED_BLANK_RE),
		(_, n) => `{{blank_${n}}}`,
	);
	return out;
};

export const extractBlankIds = (raw: string): string[] => {
	const normalized = normalizeBlankStem(raw);
	const ids: string[] = [];
	const re = cloneGlobal(CANONICAL_BLANK_RE);
	let match = re.exec(normalized);
	while (match !== null) {
		ids.push(`blank_${match[1]}`);
		match = re.exec(normalized);
	}
	return ids;
};

export const extractBlankFields = (raw: string): { blankId: string }[] =>
	extractBlankIds(raw).map((blankId) => ({ blankId }));
